import { initContract } from '@ts-rest/core'
import type { GetDeliveriesResponse } from '@repo/api-types'
import { ErrorResponseSchema } from './general'

const c = initContract()

export const deliveryContract = c.router(
  {
    getDeliveries: {
      method: 'GET',
      path: '/deliveries',
      responses: {
        200: c.type<GetDeliveriesResponse>(),
      },
    },
  },
  {
    commonResponses: {
      400: ErrorResponseSchema,
      401: ErrorResponseSchema,
      404: ErrorResponseSchema,
      500: ErrorResponseSchema,
    },
  },
)
